import { useCallback } from "react";

import { PAGE_FINANCE } from "../../_common/modules/fe-modules/Router/static";
import useCMSPageData from "../../_common/hooks/useCMSPageData";

export type UseFinanceProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useFinance = (): UseFinanceProps => {
  const { data } = useCMSPageData({
    page: PAGE_FINANCE,
    queryKey: "financePage",
  });

  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);
  const getMainContent = useCallback(() => data?.containers?.main, [data]);
  const getFooterContent = useCallback(() => data?.containers?.footer, [data]);

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useFinance;
